import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, Translate, getSortState, translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { MaintenanceReviewModal } from 'app/modules/maintenance-review-custom/MaintenanceReviewModal';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { PageFilters } from 'app/shared/components/page-filters/PageFilters';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { ISearchTypes } from 'app/shared/interfaces/searchTypesInterface';
import { IMaintenanceReview } from 'app/shared/model/maintenance-review.model';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { Loading } from 'app/shared/util/loading';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC } from 'app/shared/util/pagination.constants';
import { isAdminByCompanyType } from 'app/shared/util/role-utils';
import { getEntities } from './maintenance-review.reducer';

export const MaintenanceReview = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'reviewOrder'), props.location.search)
  );
  const [nameSearch, setNameSearch] = useState<string>('');
  const [selectMaintenanceReview, setSelectMaintenanceReview] = useState<IMaintenanceReview | null>(null);

  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const maintenanceReviewList = useAppSelector(state => state.maintenanceReview.entities);
  const loading = useAppSelector(state => state.maintenanceReview.loading);
  const totalItems = useAppSelector(state => state.maintenanceReview.totalItems);
  const searchTypes: ISearchTypes[] = [
    {
      label: translate('fleetSenseApp.maintenanceReview.maintenanceModel'),
      placeholder: translate('fleetSenseApp.maintenanceReview.searchMaintenanceModel'),
      value: nameSearch,
      setValue: setNameSearch,
    },
  ];

  const getAllEntities = useCallback(() => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        nameSearch,
      })
    );

    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  }, [paginationState]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const setActivePage = () => {
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
  };

  useEffect(() => {
    getAllEntities();
  }, [getAllEntities]);

  const { match } = props;

  return (
    <div>
      <PageHeader
        headingId="maintenance-review-heading"
        headingDataCy="MaintenanceReviewHeading"
        contentKey="fleetSenseApp.maintenanceReview.home.title"
        buttonTextKey="fleetSenseApp.maintenanceReview.home.createLabel"
        match={match}
      />

      <PageFilters setActivePage={setActivePage} searchTypes={searchTypes} showFilters={['filters']} />

      <div className="table-responsive">
        {maintenanceReviewList && maintenanceReviewList.length > 0 && !loading ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')} hidden>
                  <Translate contentKey="fleetSenseApp.maintenanceReview.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('reviewOrder')}>
                  <Translate contentKey="fleetSenseApp.maintenanceReview.reviewOrder">Review Order</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('km')}>
                  <Translate contentKey="fleetSenseApp.maintenanceReview.km">Km</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('period')}>
                  <Translate contentKey="fleetSenseApp.maintenanceReview.period">Period</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                {/*
                <th className="hand" onClick={sort('hour')}>
                  <Translate contentKey="fleetSenseApp.maintenanceReview.hour">Hour</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                */}
                <th className="hand" onClick={sort('description')} hidden>
                  <Translate contentKey="fleetSenseApp.maintenanceReview.description">Description</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('maintenanceModel.name')}>
                  <Translate contentKey="fleetSenseApp.maintenanceReview.maintenanceModel">Maintenance Model</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('company')}>
                  <Translate contentKey="fleetSenseApp.maintenanceReview.type">Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {maintenanceReviewList.map((maintenanceReview, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td hidden>
                    <Button tag={Link} to={`${match.url}/${maintenanceReview.id}`} color="link" size="sm">
                      {maintenanceReview.id}
                    </Button>
                  </td>
                  <td>{maintenanceReview.reviewOrder}</td>
                  <td>{maintenanceReview.km}</td>
                  <td>{maintenanceReview.period}</td>
                  {/*
                  <td>{maintenanceReview.hour}</td>
                  */}
                  <td hidden>{maintenanceReview.description}</td>
                  <td>{maintenanceReview.maintenanceModel.name}</td>
                  <td>{isAdminByCompanyType(maintenanceReview.company.type) ? 'Padrão' : '-'}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button onClick={() => setSelectMaintenanceReview(maintenanceReview)} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                      </Button>
                      {(!isAdminByCompanyType(maintenanceReview.company.type) || isAdmin) && (
                        <>
                          <Button
                            tag={Link}
                            to={`${match.url}/${maintenanceReview.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                            color="primary"
                            size="sm"
                            data-cy="entityEditButton"
                          >
                            <FontAwesomeIcon icon="pencil-alt" />{' '}
                            <span className="d-none d-md-inline">
                              <Translate contentKey="entity.action.edit">Edit</Translate>
                            </span>
                          </Button>
                          <Button
                            tag={Link}
                            to={`${match.url}/${maintenanceReview.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                            color="danger"
                            size="sm"
                            data-cy="entityDeleteButton"
                          >
                            <FontAwesomeIcon icon="trash" />{' '}
                            <span className="d-none d-md-inline">
                              <Translate contentKey="entity.action.delete">Delete</Translate>
                            </span>
                          </Button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.maintenanceReview.home.notFound">No Maintenance Reviews found</Translate>
            </div>
          )
        )}
        {loading && <Loading />}
      </div>
      {selectMaintenanceReview && (
        <MaintenanceReviewModal
          maintenanceReview={selectMaintenanceReview}
          toggle={() => setSelectMaintenanceReview(null)}
          isOpen={!!selectMaintenanceReview}
        />
      )}

      {totalItems ? (
        <div className={maintenanceReviewList && maintenanceReviewList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default MaintenanceReview;
